module.exports = __webpack_public_path__ + "static/img/3-normal-return.212e35d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-normal-return.png
// module id = 1334
// module chunks = 0